module.exports = __webpack_public_path__ + "img/home-case-07.f0311174.png";